export const formatPercentage = (percentage: number): string => {
  return `${(percentage * 100).toFixed(0)}%`;
};

export const formatCurrency = (amount: number, currency = 'USD', locale = 'en-US'): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);
};
